import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { UserService } from "../../../shared/services/user.service";
import { OrderService } from "../../../shared/services/order.service";
import { ParamMap, Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "src/app/shared/services/common.service";
import { ToastrService } from "ngx-toastr";
import { DOCUMENT } from "@angular/common";
@Component({
  selector: "app-order-state",
  templateUrl: "./order-state.component.html",
  styleUrls: ["./order-state.component.scss"],
})
export class OrderStateComponent implements OnInit {
  frontLang: string = localStorage.getItem("front-lang");
  page_name =
    localStorage.getItem("front-lang") == "ar" ? "حالة الطلب" : "Order State";
  public openDashboard: boolean = false;
  userLogedIn: boolean = false;
  currentUser: any;
  usre_id: any;
  user_img: any;
  existImg: boolean;
  user_full_name: any;
  orderState: any;
  datadone: boolean = false;
  date: any;
  expectedDate: { start: Date; end: Date };
  shippmentInfo: any;
  currentUrl: string = "";
  hostName: string = "";

  constructor(
    private route: ActivatedRoute,
    public user: UserService,
    public order: OrderService,
    private router: Router,
    private Commen: CommonService,
    private toastrService: ToastrService,
    public common: CommonService,
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.checkOuth();
    this.date = Date.now();
    this.route.params.subscribe((params: ParamMap) => {
      const order_id = params["id"];
      this.hostName = this.common.getDomainFromUrl();
      this.currentUrl = `https://${this.hostName}/pages/order-state/${order_id}`;
      this.order.GetStatusOfSaleInvoice(order_id).subscribe((data) => {
        if (data.data) {
          //console.log("state", data);
          this.orderState = data.data;
          this.shippmentInfo = this.orderState?.shipment_info;
          const client_id_local = JSON.parse(
            localStorage.getItem("currentUserFront")
          )?.id;
          const client_id_order = this.orderState.client_id;

          if (client_id_local !== client_id_order) {
            this.router.navigate(["/"]);
            return;
          }

          this.expectedDate = this.calculateDeliveryDates(
            this.orderState?.shipment_info
          );
          this.datadone = true;
        }
      });
    });
  }

  copyMessage(val: string) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    let coppyMessage =
      localStorage.getItem("front-lang") == "ar"
        ? "تم نسخ الكود بنجاح"
        : "Coupone Code Moved To Clipboard";
    this.toastrService.success(coppyMessage);
  }
  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }
  checkOuth() {
    if (this.user.getToken() !== null) {
      this.userLogedIn = true;
      this.currentUser = JSON.parse(this.user.getCurrentUser());
      this.usre_id = this.currentUser.id;
      this.user_img = this.currentUser.img;
      this.existImg =
        this.user_img != "" && this.user_img != null ? true : false;
      this.user_full_name = this.currentUser.user_name;
    }
    //  else {
    //   this.userLogedIn = false;
    //   this.currentUser = null;
    //   this.usre_id = "";
    //   this.existImg = false;
    //   this.user_img = "";
    //   // this.router.navigate(["/pages/login"]);
    //   this.goToLogin();
    // }
  }

  userLogOut() {
    localStorage.removeItem("currentUserFront");
    localStorage.removeItem("clientToken");
    this.userLogedIn = false;
    this.currentUser = null;
    this.usre_id = "";
    this.user_img = "";
    this.user.logout();
    // this.router.navigate(["/pages/login"]);
    this.Commen.UpdatedSetting.next("logout");
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
    // this.goToLogin();
  }

  callNumber(number) {
    window.open("tel:" + number, "_self");
  }

  loginclicked: boolean = false;

  step5Reached: boolean = false;
  stepSuccessReached: boolean = false;
  timeoutId: any;

  @ViewChild("login") loginSection;
  @ViewChild("loginFast") loginFast;

  goToLogin() {
    this.loginclicked = true;
  }

  close() {
    this.loginclicked = false;
    this.step5Reached = false;
    this.clearTimeout();
    if (this.stepSuccessReached) {
      window.location.reload();
    }
  }

  onStep5Reached() {
    this.step5Reached = true;
    this.startTimeout();
  }
  onstepSuccessReached() {
    this.stepSuccessReached = true;
  }

  startTimeout() {
    this.timeoutId = setTimeout(() => {
      this.close();
    }, 2000);
  }

  clearTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.loginFast || !this.loginSection) {
      return;
    }
    const clickedInside = this.loginFast.nativeElement.contains(event.target);
    const clickedButton = this.loginSection.nativeElement.contains(
      event.target
    );

    if (clickedInside && this.loginclicked) {
      if (this.step5Reached) {
        this.close();
      }
    } else if (!clickedInside && clickedButton && this.loginclicked) {
      this.close();
    }
  }

  //******start calculate delivery dates**********/
  months = {
    1: { en: "January", ar: "يناير" },
    2: { en: "February", ar: "فبراير" },
    3: { en: "March", ar: "مارس" },
    4: { en: "April", ar: "أبريل" },
    5: { en: "May", ar: "مايو" },
    6: { en: "June", ar: "يونيو" },
    7: { en: "July", ar: "يوليو" },
    8: { en: "August", ar: "أغسطس" },
    9: { en: "September", ar: "سبتمبر" },
    10: { en: "October", ar: "أكتوبر" },
    11: { en: "November", ar: "نوفمبر" },
    12: { en: "December", ar: "ديسمبر" },
  };
  calculateDeliveryDates(method: any): { start: any; end: any } {
    const now = new Date();
    const addHours = (date: Date, hours: number): Date => {
      return new Date(date.getTime() + hours * 60 * 60 * 1000);
    };
    // const hourShippedOrders = method.hour_shipped_orders % 24;
    const baseDate = new Date(
      this.orderState?.history_edit_invoice.at(-1).date_added
    );
    //console.log("time", now.getHours());
    const deliveryStartDate = +method.delivery_time_from
      ? addHours(baseDate, method.delivery_time_from)
      : 0;
    const deliveryEndDate = +method.delivery_time_to
      ? addHours(baseDate, method.delivery_time_to)
      : 0;
    return { start: deliveryStartDate, end: deliveryEndDate };
  }

  handleImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = "assets/images/product/placeholder2.jpg";
  }

  //******End calculate delivery dates**********/
}
